import React from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';

import { INumericBoxProps } from './types';

import styles from './NumericBox.module.scss';

export const NumericBox: React.FC<INumericBoxProps> = ({ number, variant = 'contained', className, ...rest }) => {
  return (
    <Box className={clsx(styles.box, styles[variant], className)} {...rest}>
      {number}
    </Box>
  );
};
